export default {
  SCREEN: {
    title: 'Connect Care: Phone Required'
  },
  FORM: {
    title: 'Your account needs a primary phone listed to use Connect Care.'
  },
  ERROR: {
    severity: 'error' as 'error',
    title: 'Update unsuccessful',
    subtitle: 'Your phone number failed to be updated.'
  },
  SUCCESS: {
    severity: 'success' as 'success',
    title: 'Success!',
    subtitle: 'Your phone number has been updated.'
  },
  ITEMS: {
    phoneTypes: [
      { label: 'Mobile', value: 'MOBILE' },
      { label: 'Home', value: 'HOME' },
      { label: 'Work', value: 'WORK' }
    ]
  },
  PHONE_VALIDATION: {
    required: 'Phone is required',
    invalid: 'Must be a valid phone number'
  }
};
